import { ACCOUNT_RIGHT_READ_AGENTS_PLANNING, ACCOUNT_RIGHT_READ_SITES_PLANNING } from '@/consts/rights'

const PlanningSites = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Planning/PlanningSites')
const PlanningAgents = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Planning/PlanningAgents')

export const ROUTE_NAME_PLATFORM_PLANNING_SITE = 'adminPlaningSites'
export const ROUTE_NAME_PLATFORM_PLANNING_AGENTS = 'adminPlaningAgents'
export default [
  {
    path: 'sites',
    name: ROUTE_NAME_PLATFORM_PLANNING_SITE,
    component: PlanningSites,
    meta: {
      label: 'Sites',
      isGranted: [
        ACCOUNT_RIGHT_READ_SITES_PLANNING
      ]
    }
  },
  {
    path: 'agents',
    name: ROUTE_NAME_PLATFORM_PLANNING_AGENTS,
    component: PlanningAgents,
    meta: {
      label: 'Agents',
      isGranted: [
        ACCOUNT_RIGHT_READ_AGENTS_PLANNING
      ]
    }
  }
]
